import { WidgetDefinition } from '..';

export const MapWidgetDefinition: WidgetDefinition = {
    baseType: 'Map',
    group: 'Charts',
    hasImage: false,
    highlights: ['Map'],
    icon: 'fa-globe',
    sortingOrder: 1400,
    title: 'Map',
    type: 'Map'
};